import React from 'react';
import './FormInput.css';

function FormInput({
  label,
  type = 'text',
  name,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  placeholder,
  helpText,
  options = [], // For select inputs
  rows = 3, // For textarea
  min,
  max,
  step
}) {
  const inputId = `input-${name}`;

  const renderInput = () => {
    switch (type) {
      case 'textarea':
        return (
          <textarea
            id={inputId}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            placeholder={placeholder}
            rows={rows}
            className={error ? 'error' : ''}
          />
        );

      case 'select':
        return (
          <select
            id={inputId}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            className={error ? 'error' : ''}
          >
            <option value="">Select {label}</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );

      default:
        return (
          <input
            id={inputId}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            placeholder={placeholder}
            min={min}
            max={max}
            step={step}
            className={error ? 'error' : ''}
          />
        );
    }
  };

  return (
    <div className="form-input">
      {label && (
        <label htmlFor={inputId}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      {renderInput()}
      {helpText && <small className="help-text">{helpText}</small>}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default FormInput;
